import { useTheme } from '@emotion/react';
import { Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { BASE_HOST } from '../globals';

function NotFoundPage({ missingRegionData = false }) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                textAlign: 'center',
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                p: '15px'
            }}>
            <Typography variant="h1" color="primary" gutterBottom>
                404 - Pagina Niet Gevonden
            </Typography>
            <Typography variant="h2" color="secondary" gutterBottom>
                De pagina die je zoekt bestaat niet.
            </Typography>
            <Typography variant="body1" component="p">
                Ga{' '}
                {missingRegionData ? (
                    <a
                        style={{ color: theme.palette.secondary.main }}
                        href={`${window.location.protocol}//nl.${BASE_HOST}`}>
                        terug
                    </a>
                ) : (
                    <Link style={{ color: theme.palette.secondary.main }} to="/">
                        terug
                    </Link>
                )}{' '}
                naar de homepage.
            </Typography>
        </Box>
    );
}

export default NotFoundPage;
